import { Component, OnChanges, OnInit, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { CommonService } from '../../../../services/common';
import { forkJoin, Subject, takeUntil } from 'rxjs';
import { SalesService } from '../../sales.service';
import { IconList } from '../../../../../iconlist';

@Component({
  selector: 'app-booking-cancelled-list',
  templateUrl: './booking-cancelled-list.component.html',
  styleUrl: './booking-cancelled-list.component.scss'
})

export class BookingCancelledListComponent implements OnInit, OnChanges {
  bookingListData: any[] = [];

  initials: any;
  selectedExportData: any[] = [];
  projectId: any;
  columnDefs: any[] = [];
  rowStyles: any[] = [];

  approveIcon: string = 'assets/images/' + IconList.ApprovedIcon;
  rejectIcon: string = 'assets/images/' + IconList.RejectedIcon;
  infoIcon: string = 'assets/images/' + IconList.EyeIcon;

  // For cancellation details modal
  showCancellationDetailsModal: boolean = false;
  selectedBookingForDetails: any = null;

  private destroy$ = new Subject<void>();


  constructor(public commonService: CommonService, private salesService: SalesService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.getInitials();
    this.setColumnDefs();

    this.getCancelledBookings();

  }

  ngOnChanges(changes: SimpleChanges): void {

  }

  setColumnDefs() {
    this.columnDefs = [
      // @ts-ignore
      {

        field: 'selection', columnType: 'checkbox'
      },
      {
        header: 'Booking #', field: 'id', columnType: 'text'
      },
      {
        header: 'Client Name', field: 'clientName', columnType: 'text'
      },
      {
        header: 'Agent Name', field: 'sourceName', columnType: 'text'
      },
      {
        header: 'Unit Category',
        field: 'product',
        columnType: 'text',

      },
      {
        header: 'Amount',
        field: 'amount',
        columnType: 'text'
      },
      {
        header: 'Received Amount',
        field: 'recivedAmount',
        columnType: 'text'
      },
      {
        header: 'Status',
        field: 'status',
        columnType: 'text'
      },
      {
        header: 'Details', field: 'actions', columnType: 'icon',
        config: {
          width: '80px',
          icons: [
            {
              name: 'view',
              icon: 'fa-eye',
              tooltip: 'View Details',
              isImage: false
            }
          ]
        }
      }
    ];
  }

  getCancelledBookings() {
    this.commonService.selectedProjects$
      .pipe(takeUntil(this.destroy$)).subscribe((selectedProject: any) => {
        this.bookingListData = [];
        if (selectedProject != null) {
          this.projectId = selectedProject?.id;
          forkJoin([this.salesService.getFilterBookings(this.projectId, null, null, null, null, null, true, false)
          ]).subscribe(([pendingBooking]) => {

            const bookings = pendingBooking?.result || [];
            this.bookingListData = bookings?.map((data: any) => {
              let formattedAmount: string = data?.amount?.toLocaleString('en-IN');
              data.amount = formattedAmount;
              data.originalAmount = formattedAmount?.replaceAll(',', '');
              let formattedReceivedAmount = data?.recivedAmount?.toLocaleString('en-IN');
              data.recivedAmount = formattedReceivedAmount;
              let sourceNameinitial: any = this.initials?.find(
                (initial: any) => initial?.id == data?.sourceDetail?.nameInitialsId
              );
              if (data.clientDetail) {
                data.clientName = data?.clientDetail?.nameInitialsName + '.' + ' ' + data?.clientDetail?.firstName + ' ' + data?.clientDetail?.lastName;
              }
              data.contactNumber = data?.clientDetail?.primaryPhoneNo?.replace(/(\d{5})(\d{5})/, '$1-$2');
              if (data.sourceDetail) {

                data.sourceName =
                  (sourceNameinitial ? sourceNameinitial?.name + '. ' : '') +
                  data?.sourceDetail?.firstName +
                  ' ' +
                  data?.sourceDetail?.lastName;
              }
              if (data?.unitCategoryDetail) {
                data.product = data?.unitCategoryDetail?.name;
              }
              if (data.isRequestedForCancellation) {
                data.status = "Pending For Approval";
              }
              if (data.isCancelled) {
                data.status = "Cancelled";
              }

              // Remove row-level action data, using col.config.icons now
              return data;
            });

          }, error => {
            console.error('Error:', error);
          });
        }
      });
  }

  /**
 * Get name initials for a customer name
 */
  getInitials() {
    this.salesService.getInitials().then((res: any) => {
      if (res) {
        this.initials = res?.result;
      }
    });
  }

  onCommonTableDropdownChange(event: { route: any, currentRow: any }): void {
    // this.salesService.approveCancelledBooking(event.currentRow.id).subscribe({
    //   next: (res) => {
    //     this.commonService.showSuccessToast('Booking cancellation approved successfully.');
    //     this.getCancelledBookings();
    //   },
    //   error: (err) => {
    //     this.commonService.showErrorToast(err?.error?.message || 'Failed to approve booking cancellation.');
    //   }
    // });
  }

  /**
   * Open cancellation details modal for viewing
   */
  onInfoIconClick(booking: any): void {
    this.selectedBookingForDetails = booking;
    this.showCancellationDetailsModal = true;
    this.cdr.detectChanges(); // Trigger change detection to ensure modal opens
  }

  /**
   * Handle row action from common table (icon clicks)
   */
  onRowAction(event: any): void {
    if (event?.action === 'view' || event?.action === 'viewDetails') {
      this.onInfoIconClick(event?.row);
    }
  }

  /**
   * Close cancellation details modal
   */
  closeCancellationDetailsModal(): void {
    this.showCancellationDetailsModal = false;
    this.selectedBookingForDetails = null;
  }

  onSelectedRowsChange($event: any): void {
    this.selectedExportData = $event;
  }

  ngOnDestroy(): void {
    // Signal completion to clean up subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
}
